import { ChangeEvent } from 'react';
import { TextField } from '@mui/material';

interface PhoneStepProps {
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  disabled: boolean;
  label: string;
}

export function PhoneStep({
  value,
  onChange,
  error,
  disabled,
  label,
}: PhoneStepProps) {
  return (
    <TextField
      value={value}
      onChange={onChange}
      placeholder="+79530123456"
      label={label}
      error={Boolean(error)}
      helperText={error ?? ' '}
      disabled={disabled}
      fullWidth
    />
  );
}
